<script>
import { GlButton, GlFormGroup, GlFormInputGroup, GlFormInput } from '@gitlab/ui';
import { isEmpty } from 'lodash-es';
import DeprecatedAlertWithLink from '~/javascripts/components/deprecated_alert_with_link.vue';
import {
  PROMO_CODE_PURCHASE_SUCCESS_MESSAGE,
  PROMO_CODE_INFO_LINK,
} from '~/javascripts/subscription/constants';

export default {
  name: 'PromoCodeInput',
  components: {
    GlButton,
    GlFormGroup,
    GlFormInputGroup,
    GlFormInput,
    DeprecatedAlertWithLink,
  },
  props: {
    initialPromoCode: {
      type: String,
      required: false,
      default: '',
    },
    showSuccessAlert: {
      type: Boolean,
      required: false,
      default: false,
    },
    isParentFormLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isApplyingPromoCode: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      promoCode: this.initialPromoCode || '',
    };
  },
  computed: {
    disablePromoCodeInput() {
      return this.isParentFormLoading || this.showSuccessAlert;
    },
    disablePromoCodeApplyBtn() {
      return this.disablePromoCodeInput || isEmpty(this.promoCode);
    },
    isPromoCodeValid() {
      return this.isParentFormLoading || isEmpty(this.errorMessage);
    },
    promoCodeError() {
      return this.isParentFormLoading ? '' : this.errorMessage;
    },
  },
  watch: {
    promoCodeError(val) {
      if (val) {
        this.promoCode = undefined;
      }
    },
  },
  methods: {
    handlePromoCodeSubmit() {
      this.$emit('promo-code-submit', this.promoCode);
    },
  },
  PROMO_CODE_INFO_LINK,
  PROMO_CODE_PURCHASE_SUCCESS_MESSAGE,
};
</script>

<template>
  <div>
    <gl-form-group
      label="Coupon code (optional)"
      :invalid-feedback="promoCodeError"
      :state="isPromoCodeValid"
    >
      <gl-form-input-group>
        <gl-form-input v-model.trim="promoCode" width="md" :disabled="disablePromoCodeInput" />
        <template #append>
          <gl-button
            :loading="isApplyingPromoCode"
            :disabled="disablePromoCodeApplyBtn"
            @click="handlePromoCodeSubmit"
          >
            Apply
          </gl-button>
        </template>
      </gl-form-input-group>
    </gl-form-group>
    <deprecated-alert-with-link
      v-if="showSuccessAlert"
      alert-variant="success"
      :alert-message="$options.PROMO_CODE_PURCHASE_SUCCESS_MESSAGE"
      :alert-link="$options.PROMO_CODE_INFO_LINK"
    />
  </div>
</template>
